// Package imports:
import React from 'react';
// Component imports:
import Table from 'react-bootstrap/Table';
// Service imports:
import { formatDate } from '../../services/utils';
// Type imports:
import { AlertTickData, ALERT_STATUS_TO_DISPLAY_NAME } from '../../types/api/AlertTypes';

interface IOwnProps {
    relatedAlerts: AlertTickData[];
}

const RelatedAlerts: React.FC<IOwnProps> = ({ relatedAlerts }) => {
    return (
        <div id='RelatedAlerts'>
            <h5 className='SectionTitle'>
                Related Alerts
                {relatedAlerts.length > 0 && <span className='AlertCount'> ({relatedAlerts.length})</span>}
            </h5>
            <Table className='CompressedTable'>
                <thead>
                    <tr>
                        <th scope='col'>Time</th>
                        <th scope='col'>Description</th>
                        <th scope='col'>Status</th>
                        <th scope='col'>Trader</th>
                        <th scope='col'>Outside Spread</th>
                    </tr>
                </thead>
                <tbody>
                    {relatedAlerts.length === 0 ? (
                        <tr className='NoClick'>
                            <td className='text-left EmptyTableText' colSpan={5}>
                                No related alerts.
                            </td>
                        </tr>
                    ) : (
                        relatedAlerts.map((alert, i) => (
                            <tr key={alert.ad_id ?? i} className={`alert-status-${alert.status}`}>
                                <td>{formatDate(alert.timestamp, true, true)}</td>
                                <td>{alert.description ?? alert.ad_description ?? '—'}</td>
                                <td>
                                    <span className={`StatusBadge ${alert.status ?? ''}`}>
                                        {alert.status ? ALERT_STATUS_TO_DISPLAY_NAME[alert.status] : '—'}
                                    </span>
                                </td>
                                <td>{alert.trader_id ?? '—'}</td>
                                <td>{alert.outside_spread === true ? 'Yes' : alert.outside_spread === false ? 'No' : '—'}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
        </div>
    );
};

export default RelatedAlerts;
